var app  = angular.module('app', ['ngSanitize', 'pascalprecht.translate'])

app.config(['$httpProvider', '$translateProvider', function ($httpProvider, $translateProvider) {
	$httpProvider.defaults.timeout = 5000;
	 
	//$translateProvider.translations('en', dictEN)
	//                .translations('bg', dictBG);

	//$translateProvider.preferredLanguage('bg');

	$translateProvider.fallbackLanguage('en');
	$translateProvider.registerAvailableLanguageKeys(['bg', 'en', 'es', 'esc', 'pt', 'esm','it','ro'], {
		'bg_*': 'bg',
		'en_*': 'en',
		'es_*': 'es',
		'esc_*': 'esc',
		'esm_*': 'esm',
		'pt_*': 'pt',
		'it_*': 'it',
		'ro_*': 'ro'
	});

	var ob_bg;
	var ob_en;
	var ob_es;
	var ob_esc;
	var ob_esm;
	var ob_pt;
	var ob_it;
	var ob_ro;

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/bg.json",
		success: function (json) {
			ob_bg = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/en.json",
		success: function (json) {
			ob_en = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/es.json",
		success: function (json) {
			ob_es = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/esc.json",
		success: function (json) {
			ob_esc = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/esm.json",
		success: function (json) {
			ob_esm = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/pt.json",
		success: function (json) {
			ob_pt = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/it.json",
		success: function (json) {
			ob_it = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/ro.json",
		success: function (json) {
			ob_ro = json;
		}
	});

	$translateProvider.translations('en', ob_en);
	$translateProvider.translations('es', ob_es);
	$translateProvider.translations('esc', ob_esc);
	$translateProvider.translations('esm', ob_esm);
	$translateProvider.translations('bg', ob_bg);
	$translateProvider.translations('pt', ob_pt);
	$translateProvider.translations('it', ob_it);
	$translateProvider.translations('ro', ob_ro);

	$translateProvider.preferredLanguage('bg');
	$translateProvider.preferredLanguage(lang);

 }]);